<template>
  <div class="home min-h-100">
    <display></display>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Display from "@/components/display.vue"

  export default {
    name: "home",
    components: { Display }
  }
</script>
